import React, { useState } from 'react';

// === 15+ PRODUCTS DATA ===
const products = [
  { id: "G01", cat: "Gold", name: "Royal Bridal Choker", weight: "45g", img: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?q=80&w=600" },
  { id: "G02", cat: "Gold", name: "Antique Gold Jhumka", weight: "12g", img: "https://www.dhanalakshmijewellers.com/wp-content/uploads/2020/03/antiquejhumka-5.jpg" },
  { id: "G03", cat: "Gold", name: "Temple Laxmi Necklace", weight: "65g", img: "https://img1.krishnajewellers.com/DealImages/11707/LargeImages/temple_gold__necklace_in_laxmi_pendantjpgnst0003.jpg" },
  { id: "G04", cat: "Gold", name: "Filigree Bangle Set", weight: "30g", img: "https://a.1stdibscdn.com/22-karat-yellow-gold-filigree-gem-stone-bangle-cuff-bracelet-necklace-set-for-sale/j_11951/j_47124011657297363087/j_4712401_1657297363828_bg_processed.jpg" },
  { id: "G05", cat: "Gold", name: "Traditional Kada", weight: "25g", img: "https://5.imimg.com/data5/TU/CT/GC/ANDROID-23239093/product-jpeg-500x500.jpg" },
  
  { id: "D01", cat: "Diamond", name: "Solitaire Engagement Ring", weight: "1.5 Carat", img: "https://jewelrydesigns.com/wp-content/uploads/ER1-Shop-Diamond-Engagement-Rings-1080X1080.jpg" },
  { id: "D02", cat: "Diamond", name: "Rose Gold Pendant", weight: "Diamond & Ruby", img: "https://i5.walmartimages.com/asr/3170795b-f72b-4731-9524-3e3f6f55ad5f_1.fcff42d47a379b6b4b1d3900019952ac.jpeg" },
  { id: "D03", cat: "Diamond", name: "Floral Diamond Studs", weight: "0.8 Carat", img: "https://a.1stdibscdn.com/flower-design-multi-colored-diamond-stud-earrings-in-18k-white-gold-for-sale/j_2722/j_170472421663662803580/j_17047242_1663662804024_bg_processed.jpg?width=768" },
  { id: "D04", cat: "Diamond", name: "Tennis Bracelet", weight: "2 Carat Total", img: "https://a.1stdibscdn.com/archivesE/upload/1121189/j_168963921662653554615/16896392_datamatics.jpg" },
  { id: "D05", cat: "Diamond", name: "Royal Emerald Ring", weight: "Diamond Halo", img: "https://www.montecristogems.com/images/products/417/00002.1551886865.jpg" },

  { id: "A01", cat: "Antique", name: "Victorian Era Set", weight: "Polki Work", img: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=600" },
  { id: "A02", cat: "Antique", name: "Meenakari Earrings", weight: "Hand-painted", img: "https://images.unsplash.com/photo-1635767798638-3e25273a8236?q=80&w=600" },
  { id: "A03", cat: "Antique", name: "Kundan Mathapatti", weight: "Bridal Special", img: "https://medias.utsavfashion.com/media/catalog/product/cache/1/image/500x/040ec09b1e35df139433887a97daa66f/k/u/kundan-layered-matha-patti-v1-jhu5100.jpg" },
  { id: "A04", cat: "Antique", name: "Oxidized Silver Choker", weight: "Designer Wear", img: "https://i.pinimg.com/originals/fa/1c/64/fa1c648a6faba58ac9733fd1fcc71297.jpg" },
  { id: "A05", cat: "Antique", name: "Peacock Nose Ring", weight: "Nath", img: "https://images-static.nykaa.com/media/catalog/product/e/8/e80a535JW-NYFSILM000614_3.jpg" }
];

const JewelleryBasic: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const openEnquiry = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleForm = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSuccess(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsSuccess(false);
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-[#FFFBF9] text-stone-900 font-sans selection:bg-amber-100">
      
      {/* 1. TOP RATE STRIP */}
      <div className="bg-[#4A0A0C] text-amber-200 py-2.5 px-6 border-b border-amber-900/20">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-[10px] md:text-xs font-bold uppercase tracking-[0.2em]">
          <div className="flex gap-6 overflow-hidden whitespace-nowrap">
            <span className="animate-pulse">✨ Today's Gold (22K): ₹6,940/gm</span>
            <span className="hidden sm:inline opacity-30">|</span>
            <span>Silver: ₹94,500/kg</span>
          </div>
          <div className="hidden lg:block">100% BIS Hallmarked Jewellery</div>
        </div>
      </div>

      {/* 2. NAVBAR */}
      <nav className="bg-white/80 backdrop-blur-md sticky top-0 z-[100] border-b border-amber-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-20 md:h-24 flex items-center justify-between">
          <div className="flex flex-col items-center cursor-pointer" onClick={() => window.scrollTo(0,0)}>
            <span className="text-2xl md:text-3xl font-serif font-black tracking-tighter text-[#4A0A0C]">RAJWADA</span>
            <span className="text-[8px] md:text-[10px] tracking-[0.4em] font-bold text-amber-600 uppercase">Jewellers</span>
          </div>
          
          <div className="hidden md:flex gap-10 text-[10px] font-bold uppercase tracking-[0.2em] text-stone-500">
            <a href="#collections" className="hover:text-amber-700 transition">Collections</a>
            <a href="#promise" className="hover:text-amber-700 transition">Our Promise</a>
            <a href="#contact" className="hover:text-amber-700 transition">Visit Us</a>
          </div>

          <button onClick={() => openEnquiry({name: 'General Enquiry'})} className="bg-[#4A0A0C] text-white px-6 md:px-8 py-3 rounded-full text-[10px] font-bold uppercase tracking-widest hover:bg-black transition shadow-xl">
            Enquire Now
          </button>
        </div>
      </nav>

      {/* 3. HERO SECTION */}
      <header className="relative bg-stone-100 py-16 md:py-32 px-6 overflow-hidden border-b border-amber-100">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/p6.png')] pointer-events-none"></div>
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center relative z-10">
          <div className="space-y-8 text-center lg:text-left">
            <div className="inline-block border-l-4 border-amber-600 pl-4 text-amber-600 text-[10px] font-bold uppercase tracking-[0.4em]">Crafting Legacy Since 1985</div>
            <h1 className="text-5xl md:text-8xl font-serif text-stone-900 leading-none">Timeless <br/> <span className="italic text-amber-800">Masterpieces.</span></h1>
            <p className="text-lg text-stone-500 max-w-lg mx-auto lg:mx-0 font-light leading-relaxed">Experience the royal touch with our handcrafted ornaments, designed specifically for the most cherished moments of your life.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a href="#collections" className="bg-[#4A0A0C] text-white px-12 py-4 rounded-full font-bold uppercase tracking-widest text-[10px] hover:bg-black transition">Explore Collections</a>
            </div>
          </div>
          <div className="relative group">
            <div className="relative h-[400px] md:h-[600px] w-full max-w-md mx-auto rounded-t-full overflow-hidden shadow-2xl border-[12px] border-white group-hover:border-amber-50 transition-all duration-700">
              <img src="https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=1000" className="w-full h-full object-cover transition duration-[2s] group-hover:scale-110" alt="Hero"/>
            </div>
            <div className="absolute -bottom-6 -right-6 md:-right-10 bg-white p-6 rounded-2xl shadow-2xl border border-amber-50 hidden sm:block">
               <p className="text-xs font-bold text-amber-600 uppercase tracking-widest mb-1">Authenticity</p>
               <p className="text-xl font-serif font-bold text-[#4A0A0C]">100% Certified</p>
            </div>
          </div>
        </div>
      </header>

      {/* 4. BRAND PROMISE SECTION (Length Increaser) */}
      <section id="promise" className="py-24 px-6 bg-white border-b border-amber-100">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-16 text-center">
          <div className="space-y-4">
            <span className="text-5xl block mb-6">🏛️</span>
            <h3 className="text-xl font-serif text-[#4A0A0C] uppercase tracking-wider">39 Years of Trust</h3>
            <p className="text-stone-500 text-sm leading-relaxed font-light px-4">Serving generations with unmatched transparency and the purest metals in the industry.</p>
          </div>
          <div className="space-y-4">
            <span className="text-5xl block mb-6">✨</span>
            <h3 className="text-xl font-serif text-[#4A0A0C] uppercase tracking-wider">BIS Hallmarked</h3>
            <p className="text-stone-500 text-sm leading-relaxed font-light px-4">Every piece undergoes rigorous testing to ensure it meets international purity standards.</p>
          </div>
          <div className="space-y-4">
            <span className="text-5xl block mb-6">💎</span>
            <h3 className="text-xl font-serif text-[#4A0A0C] uppercase tracking-wider">Diamond Insured</h3>
            <p className="text-stone-500 text-sm leading-relaxed font-light px-4">Our stones are GIA & IGI certified with a lifetime buy-back and exchange guarantee.</p>
          </div>
        </div>
      </section>

      {/* 5. MASSIVE COLLECTIONS (15 PRODUCTS) */}
      <section id="collections" className="py-24 px-4 md:px-8 bg-stone-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-serif text-stone-900 mb-4">Our Master Gallery</h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto"></div>
            <p className="mt-6 text-stone-400 font-bold uppercase tracking-[0.3em] text-[10px]">Gold • Diamond • Antique</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-16">
            {products.map((item, idx) => (
              <div key={idx} className="group flex flex-col items-center">
                <div className="relative h-[450px] w-full overflow-hidden bg-white rounded-lg shadow-sm border border-stone-100 p-4">
                  <img src={item.img} className="w-full h-full object-cover group-hover:scale-105 transition duration-1000" alt={item.name}/>
                  <div className="absolute top-8 left-8 bg-white/90 backdrop-blur-sm px-3 py-1 rounded text-[10px] font-black uppercase tracking-widest text-[#4A0A0C]">{item.cat}</div>
                </div>
                <div className="mt-8 text-center space-y-2 w-full">
                  <h3 className="text-xl font-serif text-stone-800">{item.name}</h3>
                  <p className="text-[10px] text-stone-400 font-bold uppercase tracking-widest">{item.weight} • ID: {item.id}</p>
                  <button 
                    onClick={() => openEnquiry(item)}
                    className="mt-4 border-b-2 border-[#4A0A0C] text-[#4A0A0C] font-black uppercase tracking-widest text-[10px] pb-1 hover:text-amber-600 hover:border-amber-600 transition"
                  >
                    Explore More & Get Price ➔
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. CONTACT SECTION */}
      <section id="contact" className="py-24 px-6 bg-white">
        <div className="max-w-5xl mx-auto bg-[#FDF7F5] rounded-[3rem] p-10 md:p-20 shadow-xl border border-amber-100 flex flex-col md:flex-row gap-16 items-center">
          <div className="md:w-1/2 space-y-8">
             <h2 className="text-4xl font-serif text-[#4A0A0C]">Visit Our Studio</h2>
             <p className="text-stone-600 leading-relaxed font-light">Experience the craftsmanship in person. Our private viewing rooms are designed for your comfort and absolute privacy.</p>
             <div className="space-y-6">
                <div className="flex gap-5 items-start">
                   <span className="text-2xl text-amber-600">📍</span>
                   <div><h4 className="font-bold text-sm uppercase tracking-widest mb-1">Showroom Address</h4><p className="text-stone-500 text-sm">Shop 42, Sarafa Market, Indore, MP 452001</p></div>
                </div>
                <div className="flex gap-5 items-start">
                   <span className="text-2xl text-amber-600">📞</span>
                   <div><h4 className="font-bold text-sm uppercase tracking-widest mb-1">Call for Booking</h4><p className="text-stone-500 text-sm">+91 98765 43210</p></div>
                </div>
             </div>
          </div>
          <div className="md:w-1/2 w-full h-[400px] bg-stone-200 rounded-[2rem] overflow-hidden shadow-inner relative">
             <img src="https://images.unsplash.com/photo-1526772662000-3f88f10405ff?q=80&w=800" className="w-full h-full object-cover grayscale opacity-50" alt="Map"/>
             <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white px-6 py-3 rounded-full shadow-2xl font-bold uppercase tracking-widest text-[10px] text-[#4A0A0C]">View On Google Maps</div>
             </div>
          </div>
        </div>
      </section>

      {/* === ENQUIRY MODAL (SMART POPUP) === */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 sm:p-6">
          <div className="absolute inset-0 bg-[#4A0A0C]/80 backdrop-blur-sm" onClick={() => setIsModalOpen(false)}></div>
          <div className="relative bg-white w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden animate-slideUp">
             <div className="p-8 md:p-12 text-center">
               <button onClick={() => setIsModalOpen(false)} className="absolute top-6 right-6 text-stone-300 hover:text-stone-900 text-2xl">×</button>
               
               {isSuccess ? (
                 <div className="py-10 space-y-6">
                   <span className="text-6xl">💎</span>
                   <h3 className="text-3xl font-serif text-[#4A0A0C]">Request Sent!</h3>
                   <p className="text-stone-500">Our relationship manager will contact you with the current price and details shortly.</p>
                 </div>
               ) : (
                 <>
                   <h3 className="text-3xl font-serif text-[#4A0A0C] mb-2">Check Details</h3>
                   <p className="text-amber-600 font-bold uppercase tracking-widest text-[10px] mb-8">Product: {selectedProduct?.name}</p>
                   
                   <form onSubmit={handleForm} className="space-y-5">
                      <input required type="text" placeholder="Your Full Name" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-amber-600 outline-none transition"/>
                      <input required type="tel" placeholder="WhatsApp Number" className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-amber-600 outline-none transition"/>
                      <textarea placeholder="Any customization? (Optional)" rows={2} className="w-full bg-stone-50 border border-stone-200 p-4 rounded-xl focus:border-amber-600 outline-none transition resize-none"></textarea>
                      <button type="submit" className="w-full bg-[#4A0A0C] text-white py-5 rounded-xl font-bold uppercase tracking-[0.2em] text-[10px] shadow-xl hover:bg-black transition">Submit Interest</button>
                   </form>
                 </>
               )}
             </div>
          </div>
        </div>
      )}

      {/* 7. FOOTER */}
      <footer className="bg-[#1A1A1A] text-stone-500 py-20 px-6 border-t-[8px] border-[#4A0A0C]">
        <div className="max-w-7xl mx-auto flex flex-col items-center text-center space-y-12">
          <div className="flex flex-col items-center">
            <span className="text-4xl md:text-5xl font-serif font-black tracking-tighter text-white">RAJWADA</span>
            <span className="text-[10px] tracking-[0.5em] font-bold text-amber-600 uppercase">Jewellers</span>
          </div>
          <p className="max-w-md text-xs uppercase tracking-[0.3em] leading-loose">Purity in Every Gram • Elegance in Every Cut • Legacy in Every Soul</p>
          <div className="w-full pt-12 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-bold tracking-widest uppercase">
            <p>© {new Date().getFullYear()} RAJWADA JEWELLERS. ALL RIGHTS RESERVED.</p>
            <div className="flex gap-10">
               <a href="#" className="hover:text-white transition">Instagram</a>
               <a href="#" className="hover:text-white transition">Facebook</a>
               <span className="text-stone-800">Premium Portfolio</span>
            </div>
          </div>
        </div>
      </footer>

      {/* Global Animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes slideUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .animate-slideUp { animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
      `}} />
    </div>
  );
};

export default JewelleryBasic;